<script setup lang="ts">
  defineOptions({
    inheritAttrs: false,
  })
</script>

<template>
  <router-view v-slot="{ Component }">
    <transition
      name="fade"
      mode="out-in">
      <component
        :is="Component"
        v-bind="$attrs" />
    </transition>
  </router-view>
</template>
